"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = serializeOptionGroups;

var _serializeOptions = _interopRequireDefault(require("./serialize-options"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * Function that transforms options within an option group array into 
 * object options with keys of `key` and `value`
 *
 * @name serializeOptionGroups
 * @type Function
 * @param {Array} optionGroupArray - Array of option values
 * @returns {Array} Array of object group options
 *
 * @example
 *
 * const optionGroups = [ 
 *  { name: 'fruits', options: ['apple', 'banana'] },
 *  { name: 'veggies', options: ['lettuce', 'pepper'] },
 * ]
 *
 * serializeOptionGroups(optionGroups)
 *
 * // [
 * //   { 
 * //     name: 'fruits', 
 * //     options: [{ key: 'apple', value: 'apple' }, { key: 'banana', value: 'banana' }] 
 * //   }, 
 * //   { 
 * //     name: 'veggies', 
 * //     options: [{ key: 'lettuce', value: 'lettuce' }, { key: 'pepper', value: 'pepper' }] 
 * //   },
 * // ]
 *
 */
function serializeOptionGroups(optionGroupArray) {
  return optionGroupArray.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      options: (0, _serializeOptions["default"])(group.options)
    });
  });
}